import styled from 'styled-components';

export const PropertySettingsChannelsTabWrapper = styled.div`
  h2 {
    font-size: 20px;
    font-weight: bold;
    margin-top: 20px;
  }

  ul {
    padding: 0;
    margin: 0;
  }
`;
